// extracted by mini-css-extract-plugin
export default {"EmptyButton":"EmptyButton_EmptyButton__bMDvV","header":"EmptyButton_header__9dexk","Subheader":"EmptyButton_Subheader__OzWLv","buttonOnclick":"EmptyButton_buttonOnclick__mfkGo"};